import { IELTFormData, TEltFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

export const isHasPlcData = (formData: TEltFormData) => {
  const formPPTXData = formData as IELTFormData
  return formPPTXData.PLC && formPPTXData.PLC.length > 0
}
